import { lazy as lazyLoad } from 'react';

import { route } from '../settings/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    SettingsPage: lazyLoad(async () => {
        const { SettingsPage } = await import('./Settings');

        return { default: SettingsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.settings.title',
        page: lazy.SettingsPage,
        path: route.patterns.settings,
    },
];
